export const getInitials = (name?: string | null): string => {
    if (!name) return "";
  
    const parts = name.trim().split(" ");
    if (parts.length === 1) {
      return parts[0][0]?.toUpperCase() ?? "";
    }
    return (
      (parts[0][0] ?? "").toUpperCase() +
      (parts[parts.length - 1][0] ?? "").toUpperCase()
    );
};

export const capitalizeFirstLetter = (text?: string | null): string => {
    if (!text) return "";
    
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export function toTitleCase(name: string): string {
  return name
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((word) => {
      // Handle initials with dot like NP., H.H., P.K.
      if (/^([A-Z]{1,}\.)+$/.test(word)) {
        return word;
      }

      // Handle titles like Dr., Mr., Ms.
      if (/^[a-zA-Z]{1,3}\.$/.test(word)) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }

      // Keep abbreviations like HH, PK
      if (word.length <= 2 && word === word.toUpperCase()) {
        return word;
      }

      // Single letters → uppercase
      if (word.length === 1) {
        return word.toUpperCase();
      }

      // Normal title case
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}